<template>
	<div id="app" class="app" ref="app">
		<MainHeader/>

		<main class="site-main">
			<router-view/>
		</main>

		<PartBackToTop/>
	</div>
</template>

<script>
import MainHeader from '@/components/main/MainHeader.vue';
import PartBackToTop from '@/components/parts/PartBackToTop';

export default {
	components: {
		MainHeader,
		PartBackToTop
	}
};
</script>

<style lang="scss" scoped>
.app {
	padding-top: 82px;
	padding-bottom: 80px;

	@include mq($xl) {
		padding-bottom: 40px;
		padding-top: 80px;
	}

	@include mq($lg) {
		padding-top: 70px;
	}
}
</style>
